import { render, staticRenderFns } from "./menu-bar.vue?vue&type=template&id=5a69a77a&"
import script from "./menu-bar.vue?vue&type=script&lang=js&"
export * from "./menu-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports